import { VBottomSheet } from 'vuetify/lib/components/VBottomSheet';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    VBottomSheet,
    _vm._g(
      _vm._b(
        {
          attrs: { "data-qa": "core-bottom-sheet" },
          model: {
            value: _setup.isOpened,
            callback: function ($$v) {
              _setup.isOpened = $$v
            },
            expression: "isOpened",
          },
        },
        "v-bottom-sheet",
        {
          ..._vm.$attrs,
          "content-class": _vm.$attrs["content-class"]
            ? `${_vm.$attrs["content-class"]} flex-dialog`
            : "flex-dialog",
        },
        false
      ),
      _vm.$listeners
    ),
    [
      _c(
        "div",
        {
          staticClass:
            "core-bottom-sheet d-flex flex-column flex-grow-1 overflow-y-auto bg-gray-0 elevation-20 h-100 position-relative gr-6",
          attrs: { "data-qa": _vm.dataQa, "data-qa-base": "core-bottom-sheet" },
        },
        [
          _vm.title || _vm.$slots.title
            ? _c(
                "div",
                {
                  staticClass: "core-bottom-sheet__container flex-shrink-0",
                  attrs: { "data-qa": "core-bottom-sheet-toolbar-container" },
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "core-bottom-sheet__toolbar",
                      attrs: { "data-qa": "core-bottom-sheet-toolbar" },
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "core-bottom-sheet__header text-break" },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "text-h6 text--text mr-auto",
                              attrs: { "data-qa": "core-bottom-sheet-title" },
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(_vm.title) +
                                  "\n            "
                              ),
                              _vm._t("title"),
                            ],
                            2
                          ),
                        ]
                      ),
                    ]
                  ),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.$scopedSlots.default || _vm.$slots.default
            ? _c(
                "div",
                {
                  staticClass:
                    "core-bottom-sheet__container d-flex flex-column flex-fill overflow-y-auto custom-scroll",
                  attrs: { "data-qa": "core-bottom-sheet-content" },
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "d-flex flex-column flex-fill",
                      class: _vm.slotContentClass,
                    },
                    [
                      _vm._t("default", null, {
                        xSpaceClass: "px-4",
                        counterXSpaceClass: "mx-n4",
                      }),
                    ],
                    2
                  ),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.$slots.actions
            ? _c(
                "div",
                {
                  staticClass:
                    "core-bottom-sheet__container flex-shrink-0 mt-auto",
                  attrs: { "data-qa": "core-bottom-sheet-actions-container" },
                },
                [
                  _c(
                    "div",
                    {
                      staticClass:
                        "core-bottom-sheet__actions d-flex align-center justify-end ga-2",
                      class: _vm.slotActionsClass,
                      attrs: { "data-qa": "core-bottom-sheet-actions" },
                    },
                    [_vm._t("actions")],
                    2
                  ),
                ]
              )
            : _vm._e(),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }